import {Button} from '@luminopia/react-toolbox/lib/button'
import Confirm from 'core/components/confirm'
import * as React from 'react'
import * as classNames from './reviewer-controls.css'

export interface IProps {
  className?: string

  deactivateButton: boolean
  isApproved: boolean
  onConfirmActivate: () => void
  onConfirmDeactivate: () => void
  onDeactivate: () => void
  isConfirmActive: boolean
}

export class ReviewerControls extends React.PureComponent<IProps, {}> {
  public static defaultProps = {
    deactivateButton: false,
    onConfirmActivate: () => undefined,
    onConfirmDeactivate: () => undefined,
    onDeactivate: () => undefined,
    isConifrmActive: false,
  }

  public render() {
    // TODO I18N
    return (
      <div className={this.props.className}>
        <div className={classNames.buttonsContainer}>
          {!this.props.isApproved && <Button
            className={classNames.button}
            raised primary
            label='activate physician'
            onClick={this.props.onConfirmActivate}
          />}
        </div>
        <Confirm
          title='Activate physican?'
          active={this.props.isConfirmActive}
          onConfirm={this.props.onDeactivate}
          onCancel={this.props.onConfirmDeactivate}
        >
          Are you sure you want to activate this physician? This will enable their access to the system.
        </Confirm>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/components/reviewers/reviewer-controls.tsx